export const HeaderKey_AdvisorSessionId = `x-advisor-session-id`;
export const HeaderKey_AppVersion = `x-app-version`;
export const StorageKey_AdvisorLastEncounterIds = `storage-advisor-last-encounter-ids`;
//# sourceMappingURL=consts.js.map